/* eslint-disable i18next/no-literal-string */
import Modal, { ModalHeader, Theatre } from '@ingka/modal';
import Table, { TableBody, TableHeader } from '@ingka/table';
import type { FieldError } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import type { QuestionsErrorFormatLimitsType, UploadErrorsType } from '../../../utils/error';
import { getLimit, getRowsWithErrors } from '../../../utils/error';
import styles from './UploadQuestionsErrorTheatre.module.scss';

export type QuestionsErrorProps = {
  open: boolean;
  error: FieldError | undefined;
  limits: QuestionsErrorFormatLimitsType;
  onClose: () => void;
};

export const UploadQuestionsErrorTheatre: React.FC<QuestionsErrorProps> = (
  props: QuestionsErrorProps
) => {
  const { open, error, limits, onClose } = props;
  const { t } = useTranslation();
  const rowsWithError: Array<UploadErrorsType> = getRowsWithErrors(error);

  return (
    <Modal visible={open} handleCloseBtn={onClose}>
      <Theatre header={<ModalHeader />}>
        <Table className={styles['modal']}>
          <TableHeader>
            <tr>
              <th>Row</th>
              <th>Question</th>
              <th>Description</th>
              <th>Correct answer text</th>
              <th>Wrong answer text</th>
              <th>Image</th>
            </tr>
          </TableHeader>
          <TableBody>
            {rowsWithError.map((row: UploadErrorsType, index) => {
              return (
                // eslint-disable-next-line react/no-array-index-key
                <tr key={index}>
                  <td>{index}</td>
                  <td>{t(row.question?.message, getLimit(row.question?.message, limits))}</td>
                  <td>{t(row.description?.message, getLimit(row.description?.message, limits))}</td>
                  <td>
                    {t(
                      row.correctAnswerText?.message,
                      getLimit(row.correctAnswerText?.message, limits)
                    )}
                  </td>
                  <td>
                    {t(
                      row.wrongAnswerText?.message,
                      getLimit(row.wrongAnswerText?.message, limits)
                    )}
                  </td>
                  <td>{t(row.image?.message, getLimit(row.image?.message, limits))}</td>
                </tr>
              );
            })}
          </TableBody>
        </Table>
      </Theatre>
    </Modal>
  );
};
